/* src/app/styleguide/vs-table/vs-table.component.css */
/*# sourceMappingURL=vs-table.component.css.map */
